interface ICSVData {
  [key: string]: string | number | boolean | Date | null | undefined;
}

interface ICSVOptions {
  headers?: Record<string, string>;
  filename: string;
  data: ICSVData[];
}

export const downloadCSV = (options: ICSVOptions): void => {
  const { filename, data, headers } = options;

  if (!data || !Array.isArray(data) || data.length === 0) {
    console.error('Invalid data provided for CSV download');
    return;
  }

  const csvContent = convertArrayToCSV(data, headers);
  const bom = '\uFEFF';
  const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', filename.endsWith('.csv') ? filename : `${filename}.csv`);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const convertArrayToCSV = (data: ICSVData[], headers?: Record<string, string>): string => {
  const keys = headers
    ? Object.keys(headers)
    : Array.from(new Set(data.flatMap((obj) => Object.keys(obj))));

  const headerRow = headers
    ? keys.map((key) => escapeCSV(headers[key] || key)).join(',')
    : keys.map((key) => escapeCSV(key)).join(',');

  const dataRows = data.map((obj) =>
    keys
      .map((key) => {
        const value = obj[key] === null || obj[key] === undefined ? '' : obj[key];
        return escapeCSV(value);
      })
      .join(','),
  );

  return [headerRow, ...dataRows].join('\n');
};

const escapeCSV = (value: any): string => {
  if (value === null || value === undefined) return '';

  if (value instanceof Date) {
    return `"${value.toISOString()}"`;
  }

  const str = String(value).trim();

  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }

  return str;
};
